module.exports = __webpack_public_path__ + "static/media/preview_chart_2_Bookings.b33dfb6c.PNG";